/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Play_PreviewInputs */

const en_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Play Preview`)
};

const fr_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer l'apercu de lecture`)
};

const de_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau abspielen/einschalten`)
};

const it_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva l'anteprima di riproduzione`)
};

const ru_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить/Выключить предварительный просмотр`)
};

const es_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar la vista previa de reproducción`)
};

const zh_cn2_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换播放预览`)
};

const ja_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューの再生を切り替える`)
};

const hi_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्ले प्रीव्यू टॉगल करें`)
};

const pt_pt2_shortcut_keys_name_toggle_play_preview = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar reprodução Pré-visualização`)
};

/**
* | output |
* | --- |
* | "Toggle Play Preview" |
*
* @param {Shortcut_Keys_Name_Toggle_Play_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_play_preview = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Play_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Play_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_play_preview(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_play_preview(inputs)
	return en_shortcut_keys_name_toggle_play_preview(inputs)
});